import { toast } from "react-toastify";
import { getRequest } from "../api/http";
import userServiceApi from "../api/userServiceApi";

export const useFetchOrganizationDetails = () => {
  const token = localStorage.getItem("token");

  const isFormFilled = (values) => {
    const {
      type,
      name,
      image,
      employeesSize,
      address,
      country,
      categories,
      subCategories,
      companyType,
      companyRegistrationNumber,
    } = values;

    // 🔹 Common mandatory fields
    if (
      !type ||
      !name?.trim() ||
      !image ||
      !employeesSize ||
      !address?.trim() ||
      !country ||
      !categories ||
      !subCategories
    ) {
      return false;
    }

    // 🔹 Country specific logic
    if (country === "United Kingdom") {
      // companyType mandatory
      if (!companyType) {
        return false;
      }

      // If Limited Company → registration number mandatory
      if (
        companyType === "Limited Company (Ltd)" &&
        !companyRegistrationNumber?.trim()
      ) {
        return false;
      }
    }

    // 🔹 Other countries → no need to check companyType & registration
    return true;
  };

  const fetchOrganizationDetails = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await getRequest(
        userServiceApi.getSingleOrganization(),
        { headers },
      );

      if (response && response.data) {
        const resData = response.data;
        const addressOutputs = resData?.addressOutputs || [];
        const sectorsOutputs = resData?.sectorsOutputs || "";

        const formValues = {
          type: resData?.type || "",
          name: resData?.name || "",
          image: resData?.mediaLink || "",
          employeesSize: resData?.size || "",
          address: addressOutputs?.length > 0 ? addressOutputs[0]?.street : "",
          country:
            addressOutputs?.length > 0
              ? addressOutputs[0]?.countryOutput?.name
              : "",
          categories: sectorsOutputs?.sectorOutput?.name
            ? sectorsOutputs?.sectorOutput?.name
            : "",
          subCategories: sectorsOutputs?.subSectorOutput?.name
            ? sectorsOutputs?.subSectorOutput?.name
            : "",
          companyType: resData?.companyType?.value || "",
          companyRegistrationNumber: resData?.companyRegistrationNumber || "",
        };
        const isFilled = isFormFilled(formValues);
        return isFilled;
      }
    } catch (error) {
      toast.error(error.error || "Something went wrong");
    }
  };

  return {
    fetchOrganizationDetails,
  };
};
